import { SelfExclusionType } from '#api/shared/@types/generated/backend/graphql-schema-types'

export default defineNuxtRouteMiddleware(async ({ name }) => {
  if (import.meta.server) return
  const { isLoggedIn } = useAuth()
  const { navigateToLocalized } = useRouterUtils()
  if (!isLoggedIn.value) throw create404Error()

  const payload = await useUserStatusLazyQuery({
    fetchPolicy: 'cache-first',
  }).load()

  const type = payload && payload?.player?.selfExclusion?.type
  if (!type) throw create404Error()

  if (type === SelfExclusionType.CoolOff && !name?.toString().includes('cool-off')) {
    return navigateToLocalized('/cool-off')
  }

  if (type === SelfExclusionType.SelfExclusion && !name?.toString().includes('self-excluded')) {
    return navigateToLocalized('/self-excluded')
  }
})
